import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssignCandidateDialogComponent } from '../assign-candidate-dialog/assign-candidate-dialog.component';
import { MissionDetailsComponent } from '../../agency-etab-missions-details/encour-component/mission-details/mission-details.component';
import { SharedModule } from '../../../../shared/shared.module';
import { SvgIconComponent } from 'angular-svg-icon';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-assign-action',
    standalone: true,
    imports: [SharedModule, SvgIconComponent, TooltipModule],
    template: `
    <div class="d-flex align-items-center gap-1">
      <svg-icon src="assets/icons/visible.svg" class="action-icon cursor-pointer" (click)="openMissionDetails()"
        [tooltip]="'Voir les détails de la mission'"></svg-icon>
      <app-button
        text="Assigner"
        srcIcon="assets/icons/plus.svg"
        (handleClick)="openAssignDialog()"
      ></app-button>
    </div>
  `,
    styles: [`:host { display: inline-block; }`]
})
export class AssignActionComponent {
    @Input() data: any;

    constructor(private dialog: MatDialog) { }

    openMissionDetails() {
        this.dialog.open(MissionDetailsComponent, {
            width: '666px',
            height: '100vh',
            position: { right: '0' },
            backdropClass: 'bg-transparent',
            data: { ...this.data, etbId: this.data?.etablissementId ?? 0 },
        });
    }

    openAssignDialog() {
        const dialogRef = this.dialog.open(AssignCandidateDialogComponent, {
            width: '800px',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
            disableClose: false,
            data: {
                mission: this.data
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'assigned') {
                // Parent will reload via MissionService events
                window.location.reload();
            }
        });
    }
}
